// Category definitions with emoji, color, and label.
export const CATEGORIES = [
    { id: "restaurant", label: "Restaurant", emoji: "🍔", color: "#FFC9A4" },
    { id: "retail", label: "Retail", emoji: "🛍️", color: "#FFD8B5" },
    { id: "warehouse", label: "Warehouse", emoji: "📦", color: "#D8E7C7" },
    { id: "delivery", label: "Delivery", emoji: "🛵", color: "#C7DDF0" },
    { id: "hotels", label: "Hotels", emoji: "🛎️", color: "#F4D0EA" },
    { id: "care", label: "Care", emoji: "💙", color: "#CFD9F5" },
    { id: "cleaning", label: "Cleaning", emoji: "🧹", color: "#E0E1E6" },
    { id: "security", label: "Security", emoji: "🛡️", color: "#F1D4D4" },
    { id: "events", label: "Events", emoji: "🎪", color: "#F3E4B8" },
];

export const CATEGORY_MAP = CATEGORIES.reduce((acc, c) => {
    acc[c.id] = c;
    return acc;
}, {});

export function categoryFor(id) {
    return CATEGORY_MAP[id] || { id, label: id, emoji: "📍", color: "#FFDCCB" };
}
